module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00193.a2d3b530.jpg";